enum POPUP_TITLES {
    Confirmation = 'Confirmation',
    ChkMailingAddConfirmation = 'Check Mailing Address Confirmation',
    AgencyProfileCompletionAlert = 'Agency Profile Completion Alert',
    PageLeaveWarning = 'Unsaved Changes',
    Transaction_type_update_warning = 'Transaction Type Update Warning',
    Ask_For_Preapprove_tran = 'Pre-approve',
    Information = 'Information',
    FundNotAvailable = 'Fund Not Available'
};
enum OLD_PREFERENCE_TRANSACTION_GRID_LABLES {
    CreatedDateandTime = 'Created Date and Time',
};

enum NEW_PREFERENCE_TRANSACTION_GRID_LABLES {
    CreatedDateandTime = 'Created Date',
};

enum FUNDING_SOURCE {
    Whatever_It_Takes = 'WIT',
    HPSP = 'HPSP',
    UpSkill_OC_CalOptima = 'Upskill1',
    Upskill_OC_Department_of_Veteran_Affairs = 'Upskill2',
    Upskill_OC_OYACPP_EDD = 'UOOE',
    WITY = 'WITY'
};

enum FUNDING_SOURCE_DESCRIPTION {
    Whatever_It_Takes = 'Whatever It Takes',
};

enum AGENCIES_BYPASS_ACCOUNT_VALIDATION {
    WayfairLLC = 'Wayfair LLC',
};

enum PAYMENT_METHOD {
    USIO_CARD = 'USIO Card',
    CHECK = 'Check',
    ACH = 'ACH'
}

enum USIO_PAYMENT_TYPE {
    USIO_CARD_PHYSICAL = 'USIO Card (physical)',
    USIO_CARD_ELECTRONIC_TEXT = 'USIO Card (electronic text)',
    USIO_CARD_ELECTRONIC_EMAIL = 'USIO Card (electronic email)',
    USIO_CARD_ATM_ELECTRONIC_EMAIL = 'USIO Card/ATM (electronic email)',
    USIO_CARD_ATM_ELECTRONIC_TEXT = 'USIO Card/ATM (electronic text)'
}

export { POPUP_TITLES, OLD_PREFERENCE_TRANSACTION_GRID_LABLES, NEW_PREFERENCE_TRANSACTION_GRID_LABLES, FUNDING_SOURCE, FUNDING_SOURCE_DESCRIPTION, AGENCIES_BYPASS_ACCOUNT_VALIDATION,PAYMENT_METHOD,USIO_PAYMENT_TYPE};
